import * as React from 'react';
import { Icon } from 'src/Components/Shared/Icon';
import { TextInputInternal } from 'src/Components/Shared/Input/TextInputInternal';

export interface IBaseInputProps<T> {
  disabled?: boolean;
  label?: string;
  value: T | undefined;
  onChange: undefined | ((newValue: T) => void);
  onChangeNullable?: undefined | ((newValue: T | undefined) => void);
  validationStatus?: 'loading' | 'valid' | 'invalid';
  errorMessage?: string;
  onEnterPressed?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  placeholder?: string;
  className?: string;
  anchorReference?: React.MutableRefObject<null>;
}

export interface ITextualInputProps extends IBaseInputProps<string> {
  type: 'text';
}

export interface IPasswordInputProps extends IBaseInputProps<string> {
  type: 'password';
}

export interface IMultilineInputProps extends IBaseInputProps<string> {
  type: 'multiline';
}

export type ITextInputProps =
  | ITextualInputProps
  | IPasswordInputProps
  | IMultilineInputProps;

export const TextInput: React.FunctionComponent<ITextInputProps> = props => {
  const [hasSeenErrorMessage, setHasSeenErrorMessage] = React.useState(
    Boolean(props.errorMessage)
  );
  React.useEffect(() => {
    if (props.errorMessage) {
      setHasSeenErrorMessage(true);
    }
  }, [props.errorMessage]);
  const errorMessage = hasSeenErrorMessage && (
    <div className={'m-1 h-5 text-left text-sm text-red-600'}>
      {props.errorMessage}
    </div>
  );
  if (!props.validationStatus) {
    return (
      <div className='w-full' ref={props.anchorReference}>
        <TextInputInternal {...props} />
        {errorMessage}
      </div>
    );
  } else {
    return (
      <div className='w-full' ref={props.anchorReference}>
        <div className={'flex items-center space-x-3'}>
          <div className={'flex-grow'}>
            <TextInputInternal {...props} />
          </div>
          <div className={''}>
            {props.validationStatus === 'invalid' && (
              <Icon name={'FcCancel'} size={25} />
            )}
            {props.validationStatus === 'valid' && (
              <Icon name={'FcOk'} size={25} />
            )}
            {props.validationStatus === 'loading' && (
              <Icon name={'FcProcess'} size={25} />
            )}
          </div>
        </div>
        {errorMessage}
      </div>
    );
  }
};
